import produce from "immer"
import type { MapDetailDto, MapDto } from "../../models/models"
import { MAP_LOAD, MAP_LOAD_LIST } from "./map.actions"
import type { IMapState, MapActions } from "./map.types"

const mapInitialState: IMapState = {
  loadedMaps: {},
  maps: []
}

export function mapReducer(currentState: IMapState | undefined, action: MapActions): IMapState {
  const state = currentState ?? mapInitialState
  switch (action.type) {
    case MAP_LOAD: {
      return replaceMap(state, action.payload as MapDetailDto)
    }
    case MAP_LOAD_LIST: {
      return loadMapList(state, action.payload as MapDto[])
    }
    default: {
      return state
    }
  }
}

function replaceMap(currentState: IMapState, map: MapDetailDto): IMapState {
  return produce(currentState, (draftState: IMapState) => {
    draftState.loadedMaps[map.id] = map
  })
}

function loadMapList(currentState: IMapState, maps: MapDto[]): IMapState {
  return produce(currentState, (draftState: IMapState) => {
    draftState.maps = maps
  })
}
